import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {map, Observable, of, tap} from 'rxjs';
import {Utils} from "../../shared/utils/generics.utils";
import {Company} from "../models/company";
import {getSupportedLanguage} from "../../shared/utils/ui.utils";
import {ExternalApiService} from "../api/external-api/external-api.service";
import {AppStateService} from "../state/app-state.service";

export const CompanyResolver: ResolveFn<Company> = (): Observable<Company> => {

  const externalApiService = inject(ExternalApiService);
  const appStateService = inject(AppStateService);
  const storedCompany = appStateService.company();

  return storedCompany ? of(storedCompany) : externalApiService.getCompany(Utils.getCompanyFromDomain(), getSupportedLanguage()).pipe(
    map((dto) => new Company(dto)),
    tap((company) => {
      appStateService.patch({company});
      return company;
    }));
};
